var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 6,
    viewBox: "0 0 21 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_124_48",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 6
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 6,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_124_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.09091V6.09091C0 2.19557 3.91231 -0.484546 7.54467 0.922464L18.5167 5.17252C20.0837 5.77952 21.7497 6.09091 23.4302 6.09091H302C310.284 6.09091 317 12.8066 317 21.0909V32C317 40.2843 310.284 47 302 47H15C6.71574 47 0 40.2843 0 32V6.09091Z",
    fill: "#F7F5F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRightArrow);
export default __webpack_public_path__ + "static/media/chat-right-arrow.d8920ea0550e078bfdcfcae069444565.svg";
export { ForwardRef as ReactComponent };